import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { selectCodeBrand } from '@/stores/selectors';
import './metallic-pill-button.css';

type Size = 'sm' | 'md' | 'lg';

/** Pre-OTP screens keep Dice navy frame; purple starts with LBS questionnaire. */
const PRE_OTP_PATHS = new Set(['/', '/age_smoker', '/pdpa', '/uniquecode', '/otp']);

export type MetallicPillButtonProps = {
  children: ReactNode;
  size?: Size;
  className?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'>;

export default function MetallicPillButton({
  children,
  size = 'md',
  className,
  type = 'button',
  ...rest
}: MetallicPillButtonProps) {
  const { pathname } = useLocation();
  const codeBrand = useAppSelector(selectCodeBrand);
  const useLbsFrame = codeBrand === 'LBS' && !PRE_OTP_PATHS.has(pathname);

  return (
    <button
      type={type}
      className={clsx(
        'metallic-pill',
        useLbsFrame && 'metallic-pill--lbs',
        size === 'sm' && 'metallic-pill--sm',
        size === 'lg' && 'metallic-pill--lg',
        className
      )}
      {...rest}
    >
      <span className="metallic-pill__inner">{children}</span>
    </button>
  );
}
